var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.333 2.5H2.5A.5.5 0 0 0 2 3v5h8V3a.5.5 0 0 0-.5-.5H7.666l-.6.45a1.5 1.5 0 0 1-.9.3h-.333a1.5 1.5 0 0 1-.9-.3zm3.171-1H9.5A1.5 1.5 0 0 1 11 3v5h.313a.6.6 0 0 1 .5.933l-.6.9a1.5 1.5 0 0 1-1.248.667h-7.93a1.5 1.5 0 0 1-1.248-.668l-.6-.9A.6.6 0 0 1 .688 8H1V3a1.5 1.5 0 0 1 1.5-1.5h5.005M1.434 9l.185.277a.5.5 0 0 0 .416.223h7.93a.5.5 0 0 0 .416-.223L10.566 9z",
    clipRule: "evenodd"
  })));
});
const SvgDeviceNotebooksmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceNotebooksmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjMzMzE5IDIuNTAwMDJIMi41QzIuMjIzODYgMi41MDAwMiAyIDIuNzIzODggMiAzLjAwMDAyVjguMDAwMDJIMTBWMy4wMDAwMkMxMCAyLjcyMzg4IDkuNzc2MTQgMi41MDAwMiA5LjUgMi41MDAwMkg3LjY2NjQ1TDcuMDY2MzkgMi45NDk5M0M2LjgwNjc4IDMuMTQ0NTcgNi40OTEwNSAzLjI0OTc5IDYuMTY2NTggMy4yNDk3OUg1LjgzMzA3QzUuNTA4NTkgMy4yNDk3OSA1LjE5Mjg3IDMuMTQ0NTcgNC45MzMyNiAyLjk0OTkzTDQuMzMzMTkgMi41MDAwMlpNNy41MDQyNiAxLjUwMDAySDkuNUMxMC4zMjg0IDEuNTAwMDIgMTEgMi4xNzE2IDExIDMuMDAwMDJWOC4wMDAwMkgxMS4zMTMyQzExLjc5MjUgOC4wMDAwMiAxMi4wNzgzIDguNTM0MTEgMTEuODEyNSA4LjkzMjg0TDExLjIxMyA5LjgzMjA3QzEwLjkzNDggMTAuMjQ5NCAxMC40NjY0IDEwLjUgOS45NjQ5MSAxMC41SDIuMDM1MjhDMS41MzM3NSAxMC41IDEuMDY1NCAxMC4yNDk0IDAuNzg3MjAzIDkuODMyMDdMMC4xODc3MTYgOC45MzI4NEMtMC4wNzgxMDYxIDguNTM0MTEgMC4yMDc3MyA4LjAwMDAyIDAuNjg2OTQ2IDguMDAwMDJIMVYzLjAwMDAyQzEgMi4xNzE2IDEuNjcxNTcgMS41MDAwMiAyLjUgMS41MDAwMkg0LjQ5NTM4QzQuNDk4NiAxLjQ5OTk5IDQuNTAxODEgMS40OTk5OSA0LjUwNTAzIDEuNTAwMDJINy40OTQ2MUg3LjUwNDI2Wk0xLjQzNDM1IDkuMDAwMDJMMS42MTkyNSA5LjI3NzM3QzEuNzExOTkgOS40MTY0NyAxLjg2ODEgOS41MDAwMiAyLjAzNTI4IDkuNTAwMDJIOS45NjQ5MUMxMC4xMzIxIDkuNTAwMDIgMTAuMjg4MiA5LjQxNjQ3IDEwLjM4MDkgOS4yNzczN0wxMC41NjU4IDkuMDAwMDJIMS40MzQzNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";